/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 我的积分获取记录
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class TakeParams {
  constructor(public pageNum: number, public pageSize: number) {}
}

export default async function (
  params: TakeParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.Page<member.IntegralIncomeDTO>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/integral/incomes`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
